module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Crop"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fcc28262"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Crop.vue
// module id = 802
// module chunks = 1474